import { Injectable } from "@angular/core";

import { map, takeWhile, timer } from "rxjs";

@Injectable({
    providedIn: 'root'
})

export class OtpService {
    initOtpTimer(seconds: number) {
        return timer(0, 1000).pipe(
            map((x) => (seconds - x) * 1000),
            takeWhile(x => x >= 0)
        )
    }
}